var swiper = new Swiper(".thumbs-swiper", {
  spaceBetween: 8,
  slidesPerView: 5.2,
  threshold: 5,
  centeredSlides: true,
  centeredSlidesBounds: true,
  slideToClickedSlide: true,
  freeMode: {
    enabled: true,
    sticky: true,
  },
  navigation: {
    nextEl: ".product__thumb-arrow--next",
    prevEl: ".product__thumb-arrow--prev",
  },
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar",
  },
  breakpoints: {
    992: {
      spaceBetween: 16,
      direction: "vertical",
      loop: false,
      slidesPerView: 5,
    },
    1600: {
      spaceBetween: 16,
      direction: "vertical",
      loop: false,
      slidesPerView: 7,
    },
  },
});
var swiper2 = new Swiper(".product-gallery-swiper", {
  spaceBetween: 4,
  slidesPerView: 1.1,
  thumbs: {
    swiper: swiper,
  },
  breakpoints: {
    992: {
      spaceBetween: 0,
      slidesPerView: 1,
    },
  },
});

function checkPriceChange(initialPrice) {
  setTimeout(() => {
    const currentPriceElement = document.querySelector(
      ".product-block--price span[data-product-price] .money"
    );
    if (currentPriceElement) {
      const addToCartTextElement = document.querySelector(
        "[data-add-to-cart-text]"
      );

      if (addToCartTextElement) {
        const existingPipeSymbol =
          addToCartTextElement.querySelector(".pipe_symbol");
        const existingUpdatedPrice = addToCartTextElement.querySelector(
          ".variant_updated_price"
        );

        if (existingPipeSymbol) existingPipeSymbol.remove();
        if (existingUpdatedPrice) existingUpdatedPrice.remove();

        const pipeSymbol = document.createElement("span");
        pipeSymbol.className = "pipe_symbol";
        pipeSymbol.textContent = "|";

        const updatedPrice = document.createElement("span");
        updatedPrice.className = "variant_updated_price";
        updatedPrice.textContent = currentPriceElement.textContent;

        addToCartTextElement.appendChild(pipeSymbol);
        addToCartTextElement.appendChild(updatedPrice);
      }
    }
  }, 500);
}

function handleSelectChange() {
  const selectElement = document.querySelector(
    ".variant-input-wrap select[data-variant-input]"
  );

  if (selectElement) {
    selectElement.addEventListener("change", () => {
      setTimeout(() => {
        const currentPriceElement = document.querySelector(
          ".product-block--price span[data-product-price] .money"
        );

        if (currentPriceElement) {
          const addToCartTextElement = document.querySelector(
            "[data-add-to-cart-text]"
          );

          if (addToCartTextElement) {
            const existingPipeSymbol =
              addToCartTextElement.querySelector(".pipe_symbol");
            const existingUpdatedPrice = addToCartTextElement.querySelector(
              ".variant_updated_price"
            );

            if (existingPipeSymbol) existingPipeSymbol.remove();
            if (existingUpdatedPrice) existingUpdatedPrice.remove();

            const pipeSymbol = document.createElement("span");
            pipeSymbol.className = "pipe_symbol";
            pipeSymbol.textContent = "|";

            const updatedPrice = document.createElement("span");
            updatedPrice.className = "variant_updated_price";
            updatedPrice.textContent = currentPriceElement.textContent;

            addToCartTextElement.appendChild(pipeSymbol);
            addToCartTextElement.appendChild(updatedPrice);
          }
        }
      }, 500);
    });
  } else {
    console.log("there is no selection");
  }
}

function matchAndNavigateSwipers() {
  document
    .querySelectorAll(".product-swatch--custom-box")
    .forEach((customBox) => {
      if (customBox) {
        customBox.addEventListener("click", function () {
          const span = this.querySelector("span");
          if (!span) return;

          const spanValue = span.textContent.trim();
          const variants = spanValue
            .split(",")
            .map((variant) => variant.trim());

          let found = false;

          document
            .querySelectorAll(".product__thumb-item")
            .forEach((thumb, index) => {
              if (found) return;

              const img = thumb.querySelector("img");
              if (img) {
                const altText = img.getAttribute("alt");
                if (variants.some((variant) => altText.includes(variant))) {
                  swiper.slideTo(index);
                  swiper2.slideTo(index);
                  found = true;
                }
              }
            });

          const initialPriceElement = document.querySelector(
            ".product-block--price span[data-product-price] .money"
          );
          if (initialPriceElement) {
            checkPriceChange(initialPriceElement.textContent);
          }
        });
      }
    });
}

// window.addEventListener('DOMContentLoaded', matchAndNavigateSwipers);
// window.addEventListener('resize', matchAndNavigateSwipers);

function copyElementsForMobile() {
  const productBlockHeader = document.querySelector(".product-block--header");
  const looxRating = document.querySelector(".loox-rating");
  const productBlockHeaderMobile = document.querySelector(
    ".product-block--header__mobile"
  );
  const breadcrumb = productBlockHeaderMobile.querySelector("nav.breadcrumb");

  if (window.innerWidth <= 990) {
    if (productBlockHeader && looxRating && productBlockHeaderMobile) {
      if (!productBlockHeaderMobile.getAttribute("data-cloned")) {
        // breadcrumb'u geçici olarak sakla
        let breadcrumbTemp = null;
        if (breadcrumb) {
          breadcrumbTemp = breadcrumb.cloneNode(true); // breadcrumb'u klonla
          breadcrumb.remove(); // breadcrumb'u DOM'dan kaldır
        }

        // productBlockHeader'ı klonlayıp ekle
        const headerContentClone = productBlockHeader.cloneNode(true);
        while (headerContentClone.firstChild) {
          productBlockHeaderMobile.appendChild(headerContentClone.firstChild);
        }

        // looxRating'i klonlayıp ekle
        if (!productBlockHeaderMobile.querySelector(".loox-rating")) {
          const looxRatingClone = looxRating.cloneNode(true);
          productBlockHeaderMobile.appendChild(looxRatingClone);
        }

        // breadcrumb'u tekrar ekle
        if (breadcrumbTemp) {
          productBlockHeaderMobile.insertBefore(
            breadcrumbTemp,
            productBlockHeaderMobile.firstChild
          );
        }

        productBlockHeaderMobile.setAttribute("data-cloned", "true");
      }
    }
  } else {
    // breadcrumb'u saklayıp içeriği temizle
    let breadcrumbTemp = null;
    if (breadcrumb) {
      breadcrumbTemp = breadcrumb.cloneNode(true); // breadcrumb'u klonla
    }

    productBlockHeaderMobile.innerHTML = ""; // Diğer içerikleri temizle

    if (breadcrumbTemp) {
      productBlockHeaderMobile.appendChild(breadcrumbTemp); // breadcrumb'u tekrar ekle
    }

    productBlockHeaderMobile.removeAttribute("data-cloned");
  }
}

function observePriceChange() {
  var desktopPrice = document.querySelector(
    ".product-block--header .product-block--price"
  );
  var mobilePrice = document.querySelector(
    ".product-block--header__mobile .product-block--price"
  );

  if (!desktopPrice || !mobilePrice) return;

  var observer = new MutationObserver(() => {
    mobilePrice.innerHTML = desktopPrice.innerHTML;
  });

  observer.observe(desktopPrice, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

function priceUpdateVariantClick() {
  var variantButtons = document.querySelectorAll(".variant__button-label");
  if (variantButtons) {
    var desktopPrice = document.querySelector(
      ".product-block--header .product-block--price"
    );
    var mobilePrice = document.querySelector(
      ".product-block--header__mobile .product-block--price"
    );
    variantButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (mobilePrice) mobilePrice.innerHTML = desktopPrice.innerHTML;
      });
    });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  matchAndNavigateSwipers();
  copyElementsForMobile();
  observePriceChange();
  priceUpdateVariantClick();
  handleSelectChange();
});

window.addEventListener("resize", () => {
  matchAndNavigateSwipers();
  copyElementsForMobile();
  priceUpdateVariantClick();
});
